/* eslint-disable @stylistic/max-len */
export enum PayeeRelationshipStatusId {
  /**
   * It has come from the TMS, but the carrier hasnt logged in and claimed the relationship
   */
  Unregistered = 1,
  /**
   * A payee has registered in the Triumph Payments system and claimed that relationship
   */
  Connected = 2,
  /**
   * Funds are witheld and is the direct result of a payor informing us to withold all invoices for a given relationship or our own internal risk assessment tools.
   */
  Held = 8,
  /**
   * The relationship is Factored.
   */
  Factored = 9,
  /**
   * The relationship is Factored. The difference between Factored and FactorLocked is legacy.
   */
  FactorLocked = 10,
}
